export default __webpack_public_path__ + "static/media/job_svg_one.dbf022ed.svg";